export default __webpack_public_path__ + "static/media/getting-started-rocket.9faf0bd7.png";